import { Fragment, useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { getCategories } from "../../../store/slices/categories";
import CreateCategoryModal from "./components/createCategoryModal";
import { useDebounce } from "../../../Hooks/useDebounce";

const CategoriesTable = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearch = useDebounce(searchQuery, 300);
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterSearch = useDebounce(columnFilters, 300);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const columns = useMemo(
    () => [
      {
        accessorKey: "ID",
        header: "Category ID",
        size: 150,
      },
      {
        accessorKey: "name",
        header: "Category Name",
        size: 150,
      },
      {
        accessorKey: "description",
        header: "Description",
        size: 150,
      },
      {
        accessorKey: "type",
        header: "Benefit Type",
        size: 150,
      },
      {
        accessorKey: "slug_name",
        header: "Slug Name",
        size: 150,
      },
    ],
    [],
  );

  const fetchData = async (payload) => {
    const sortField = sorting.length > 0 ? sorting[0].id : undefined;
    const sortOrder = sorting.length > 0 ? (sorting[0].desc ? "desc" : "asc") : undefined;
    
    const queryPayload = {
      pagination: true,
      limit: pageSize,
      offset: page * pageSize,
      ...(sortField && { sortBy: sortField }),
      ...(sortOrder && { sortOrder: sortOrder }),
      ...payload,
    };
    
    let res = await dispatch(getCategories(queryPayload));
    if (res?.payload) {
      const p = res.payload;
      setData(p.categoriesData || p.categories || p.data || p.result || (Array.isArray(p) ? p : []));
      setTotalCount(p.count !== undefined ? p.count : (p.total !== undefined ? p.total : (Array.isArray(p) ? p.length : 0)));
    }
  };

  useEffect(() => {
    fetchData({ searchQuery: debouncedSearch, filters: columnFilterSearch });
  }, [dispatch, page, pageSize, debouncedSearch, columnFilterSearch, sorting]);

  const getCategoriesData = () => {
    fetchData({ searchQuery: debouncedSearch, filters: columnFilterSearch });
  };

  const handlePageChange = (event) => {
    const newState = typeof event === "function" ? event({ pageIndex: page, pageSize: pageSize }) : event;
    setPage(newState.pageIndex);
    setPageSize(newState.pageSize);
  };

  const handleOnChangeSearch = (value) => {
    setSearchQuery(value);
    setPage(0);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        cursor: "pointer",
      },
    }),
    initialState: { density: "compact" },
    globalFilter: searchQuery,
    onGlobalFilterChange: handleOnChangeSearch,
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
    rowCount: totalCount || 0,
    onPaginationChange: handlePageChange,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    state: {
      pagination: { pageIndex: page, pageSize: pageSize },
      sorting,
      columnFilters,
      globalFilter: searchQuery,
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <div className="d-flex">
        <div
          sx={{
            display: "flex",
            gap: "16px",
            padding: "8px",
            flexWrap: "wrap",
          }}
        >
          <button className="btn bg-primary" onClick={() => setModalOpen(true)}>
            Create Category
          </button>
        </div>
      </div>
    ),
  });

  const toggle = useCallback(() => {
    console.log("modal close");
    getCategoriesData();
    setModalOpen(!isModalOpen);
  }, [isModalOpen]);

  return (
    <Fragment>
      <CreateCategoryModal isOpen={isModalOpen} toggle={() => toggle()} />
      <Breadcrumbs mainTitle="Categories" parent="Categories" parentPath="service-categories" title="Categories List" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <MaterialReactTable table={table} />
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CategoriesTable;
